"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppInForeground = void 0;
const isAppInForeground = () => true;
exports.isAppInForeground = isAppInForeground;
